'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BasePatternFactory = require('../lib/BasePatternFactory');

var _BasePatternFactory2 = _interopRequireDefault(_BasePatternFactory);

var _IosUARegex = require('../regex/IosUARegex');

var _IosUARegex2 = _interopRequireDefault(_IosUARegex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _BasePatternFactory2.default)({
  name: 'IosUA',
  validator: function validator(input) {
    return _IosUARegex2.default.test(input);
  }
});
module.exports = exports['default'];